import React from "react";
import { Box, Button, Flex, Image, Text as CText, Spinner, useClipboard } from "@chakra-ui/react";
import { CopyIcon, CheckIcon, LinkIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";

// TODO: Issue MRP-2775
// eslint-disable-next-line import/no-unresolved
import { ArrowRight } from "ui-kit/icon";
import { ReferFriend as refer } from "static/images";

const DollarCircle = () => (
  <Flex
    align="center"
    justify="center"
    w="24px"
    h="24px"
    borderRadius="full"
    border="2px solid #0A92B8"
    flexShrink={0}
  >
    <CText fontSize="11px" fontWeight="700" color="#0A92B8" mt="1px">
      $
    </CText>
  </Flex>
);

const DollarCircleIcons = () => (
  <Flex gap="1" flexShrink={0}>
    <DollarCircle />
    <DollarCircle />
    <DollarCircle />
  </Flex>
);

const ReferralContent = ({ isLoading, shareUrl, hasCopied, onCopy, onReferClick }) => {
  if (isLoading) {
    return (
      <Flex align="center" justify="center" py="2">
        <Spinner size="sm" color="#0A92B8" />
      </Flex>
    );
  }

  if (shareUrl) {
    return (
      <Flex
        align="center"
        bg="white"
        border="1px solid #C4DDE3"
        borderRadius="xl"
        px="3"
        py="2"
        gap="2"
      >
        <LinkIcon color="#0A92B8" boxSize="4" flexShrink={0} />
        <CText fontSize="13px" color="#2D3848" isTruncated flex="1">
          {shareUrl}
        </CText>
        <Button
          size="xs"
          variant="outline"
          borderColor="#C4DDE3"
          color="#2D3848"
          fontSize="11px"
          fontWeight="600"
          letterSpacing="0.5px"
          textTransform="uppercase"
          borderRadius="md"
          px="2"
          h="28px"
          leftIcon={hasCopied ? <CheckIcon boxSize="2.5" /> : <CopyIcon boxSize="2.5" />}
          onClick={onCopy}
          flexShrink={0}
          _hover={{ bg: "gray.50" }}
        >
          {hasCopied ? "Copied!" : "Copy link"}
        </Button>
      </Flex>
    );
  }

  return (
    <Box
      as="button"
      onClick={onReferClick}
      display="flex"
      alignItems="center"
      gap="2px"
      background="none"
      border="none"
      padding="0"
      cursor="pointer"
    >
      <CText fontSize="14px" fontWeight="500" color="#086883" textDecoration="underline">
        Refer Here
      </CText>
    </Box>
  );
};

const LegacyFeaturePanel = () => (
  <Flex flexDir="row" shadow="0 -3pt 6pt hsla(0, 0%, 0%, 0.1)" borderTopRadius="10px">
    <Link to="/refer-friend/" style={{ width: "234px", height: "123px" }}>
      <Image src={refer} alt="Refer logo" width="134px" height="123px" borderTopRightRadius="8px" />
    </Link>
    <Box color="blue.darkest" padding="12px 26px 0px 20px" letterSpacing="0px">
      <CText fontSize="10px" lineHeight="12.5px" fontWeight="500" color="#6F7F98">
        NEW
      </CText>
      <CText fontSize="14px" lineHeight="20px" fontWeight="500" color="#2D3848">
        $100 Awaits You!
      </CText>
      <CText fontSize="14px" lineHeight="20px" fontWeight="500" color="#00252F" opacity="0.5">
        Refer your friends to us, get rewarded.
      </CText>
      <Link to="/refer-friend/">
        <Box display="flex" alignItems="center" marginBottom="6px" gap="2px">
          <CText fontSize="14px" fontWeight="500" color="#086883" textDecoration="underline">
            Refer Here
          </CText>
          <Box as={ArrowRight} width="7.5px" height="6.43" />
        </Box>
      </Link>
    </Box>
  </Flex>
);

const NewFeaturePanel = ({ onReferClick, shareUrl, isLoading }) => {
  const { hasCopied, onCopy } = useClipboard(shareUrl || "");

  if (!onReferClick) {
    return <LegacyFeaturePanel />;
  }

  return (
    <Flex
      flexDir="column"
      gap="3"
      borderTopRadius="10px"
      borderBottomRadius="0"
      p="5"
      pb="6"
      bg="#D9F2F8"
    >
      <Flex align="center" justify="space-between">
        <Box
          bg="#0A92B8"
          color="white"
          fontSize="11px"
          fontWeight="700"
          letterSpacing="2px"
          px="3"
          py="1"
          borderRadius="full"
        >
          REFERRAL PROGRAM
        </Box>
        <DollarCircleIcons />
      </Flex>

      <Box>
        <CText fontSize="16px" lineHeight="22px" fontWeight="700" color="#00252F">
          Help another retailer and get $100!
        </CText>
        <CText fontSize="13px" lineHeight="18px" color="#6F7F98" mt="1">
          Know someone sitting on inventory?<br />Send them this link. They join, you get paid.
        </CText>
      </Box>

      <ReferralContent
        isLoading={isLoading}
        shareUrl={shareUrl}
        hasCopied={hasCopied}
        onCopy={onCopy}
        onReferClick={onReferClick}
      />
    </Flex>
  );
};

export default NewFeaturePanel;
